export const enum GameOutcome {
  WIN,
  LOSE,
}
